@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Upscaling Fluid Flow Models</h1>

<mat-card class="manager-card">
  <div class="manager-layout">
    <div class="left-panel">
      <div class="file-info-card">
        <div class="info-row">
          <span class="info-label">Rock File:</span>
          <span class="info-value">{{ rockFileName | removeExtension }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Size:</span>
          <span class="info-value">{{ getFileSizeDisplay() }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Rock Model:</span>
          <a class="info-value link" [href]="getRockModelUrl()" target="_blank">{{ rockModelName }}</a>
        </div>
      </div>

      <div class="image-preview-card">
        <div class="image-header">Upscaling Segmented Rock Image</div>
        <div class="image-and-phases-row">
          <div class="image-container">
            @if (thumbnailUrl) {
              <img [src]="thumbnailUrl" alt="Rock image thumbnail" class="rock-thumbnail" />
            } @else {
              <div class="placeholder-image">
                <mat-icon>image</mat-icon>
                <p>No preview available</p>
              </div>
            }
          </div>
          <div class="view-phases-panel">
            @if (phases.length) {
              <div class="view-phases-table-container">
                <table class="view-phases-table">
                  <thead>
                    <tr>
                      <th>Phase</th>
                      <th>Label</th>
                      <th>Fraction</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (phase of phases; track phase.phase) {
                      <tr>
                        <td>
                          <div class="phase-indicator" [style.background-color]="phase.color || 'rgb(128, 128, 128)'"></div>
                        </td>
                        <td>{{ phase.label }}</td>
                        <td>{{ phase.fraction | number : '1.3-3' }}</td>
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr class="total-row">
                      <td colspan="2">Total</td>
                      <td>{{ totalFraction | number : '1.3-3' }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            } @else {
              <div class="view-phases-empty">Phase data not available</div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="right-panel">
      <div class="simulation-info-card">
        <div class="info-row">
          <span class="info-label">Simulation name:</span>
          <a class="info-value link" [href]="getSimulationResultsUrl()" target="_blank">{{ simulationName }}</a>
        </div>
        <div class="info-row directions-row">
          @for (dir of simulationDirections; track dir.direction) {
            <span class="info-label">{{ dir.direction }}:</span>
            <mat-chip
              [ngClass]="getStatusClass(dir.status)"
              class="direction-status"
            >
              {{ dir.status }}
            </mat-chip>
          }
        </div>
      </div>

      <div class="models-table-container">
        <h2 class="table-title">Fluid Flow Models</h2>

        <div class="table-wrapper">
          <table class="models-table mat-elevation-z2">
            <thead>
              <tr>
                <th>Name</th>
                <th>Direction</th>
                <th>Flow units</th>
                <th>Interfacial<br/>tension<br/>interval (N/m)</th>
                <th>Contact<br/>angle<br/>interval<br/>(PD)</th>
                <th>Contact<br/>angle<br/>interval<br/>(FI)</th>
              </tr>
            </thead>
            <tbody>
              @if (!fluidFlowModels.length) {
                <tr>
                  <td class="empty-state" colspan="6">
                    No fluid flow models yet. Click "Create Fluid Flow Model" to create one.
                  </td>
                </tr>
              } @else {
                @for (model of fluidFlowModels; track model.id) {
                  <tr
                    (click)="onRowClick(model)"
                    [class.selected]="model.id === selectedModel?.id"
                  >
                    <td>{{ model.name }}</td>
                    <td>{{ model.direction }}</td>
                    <td>{{ model.flowUnits }}</td>
                    <td>{{ formatRange(model.interfacialTensionMin, model.interfacialTensionMax) }}</td>
                    <td>{{ formatRange(model.primaryDrainageMin, model.primaryDrainageMax) }}</td>
                    <td [class.not-selected]="!model.hasFirstImbibition">
                      {{ model.hasFirstImbibition ? formatRange(model.firstImbibitionMin, model.firstImbibitionMax) : 'Not Selected' }}
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="actions-row">
        <button class="btn btn-primary" (click)="newFluidFlowModel()">
          Create Fluid Flow Model
        </button>
        <button
          class="btn btn-secondary"
          [disabled]="!selectedModel"
          (click)="viewFluidFlowModel()"
        >
          View Fluid Flow Model
        </button>
        <button
          class="btn btn-secondary"
          [disabled]="!selectedModel"
          (click)="duplicateFluidFlowModel()"
        >
          Clone Fluid Flow Model
        </button>
        <button
          class="btn btn-warn"
          [disabled]="!selectedModel"
          (click)="deleteFluidFlowModel()"
        >
          Delete Fluid Flow Model
        </button>
      </div>
    </div>
  </div>
</mat-card>
